/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartContainerSX: SxProps = {
	position: 'relative',
};

export const frameCountCartSX: SxProps = {
	alignItems: 'center',
	paddingTop: '0px',
	position: 'relative',
	color: 'text.primary',
	'&:hover': {
		color: 'primary.main',
	},
};

export const numberCountCartSX = ({ isMobile }: { isMobile?: boolean }): SxProps => ({
	fontSize: isMobile ? '14px' : '12px',
	fontWeight: 'bold',
	letterSpacing: '0px',
	position: 'absolute',
	top: '-14px',
});

export const iconCountCartSX = ({ isMobile }: { isMobile?: boolean }): SxProps => ({
	fontSize: isMobile ? '23px' : '21px',
});
